import { Close } from "@mui/icons-material";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import { useEffect, useState } from "react";

import HNSColors from "../../../../../ui library/HNSColors";
import { STYLES } from "../../utils/customStyles";

export default function CustomTextField({
  placeholder,
  fieldName,
  fieldValue,
  onChange,
  multiline = false,
  noClearIcon = false,
  readOnly = false,
  disabled = false,
  error = false,
  helperText = "",
  inputMode,
  maxLength,
}) {
  const [localValue, setLocalValue] = useState(fieldValue ?? "");

  useEffect(() => {
    setLocalValue(fieldValue ?? "");
  }, [fieldValue]);

  const handleClear = () => {
    setLocalValue("");
    onChange(fieldName, "");
  };

  const handleChange = (e) => {
    if (readOnly || disabled) {
      return;
    }
    setLocalValue(e.target.value);
    onChange(fieldName, e.target.value);
  };

  return (
    <div className="flex-1">
      <TextField
        id="search-bar"
        multiline={multiline}
        rows={multiline ? 5 : 1}
        placeholder={placeholder}
        className="w-full"
        variant="outlined"
        value={localValue}
        onChange={handleChange}
        disabled={disabled}
        error={error}
        helperText={helperText}
        InputLabelProps={{ shrink: true }}
        InputProps={{
          readOnly,
          endAdornment:
            localValue && !noClearIcon && !readOnly && !disabled ? (
              <InputAdornment position="end" className="p-4">
                <IconButton onClick={handleClear} edge="end" size="small">
                  <Close fontSize="small" />
                </IconButton>
              </InputAdornment>
            ) : null,
        }}
        inputProps={{
          inputMode,
          maxLength,
        }}
        sx={{
          ...STYLES.textField,
          ...(readOnly
            ? {
                "& .MuiOutlinedInput-root": {
                  ...STYLES.textField["& .MuiOutlinedInput-root"],
                  backgroundColor: HNSColors.neutrals[850] ?? HNSColors.neutrals[800],
                  "& .MuiInputBase-input": {
                    ...STYLES.textField["& .MuiOutlinedInput-root"]["& .MuiInputBase-input"],
                    color: HNSColors.neutrals[500],
                  },
                },
              }
            : {}),
        }}
        size="small"
      />
    </div>
  );
}
